export default __webpack_public_path__ + "static/media/11.8.a91a158f.jpg";